/* Const,Let & Var will be here */
export const DATE_SELECTION = 'DATE_SELECTION';
export const LAST_ACTIVITY_DATE_TIME = 'LAST_ACTIVITY_DATE_TIME';

/* Const,Let & Var will be here */

export function onSelectDate(date) {
    return {
        type: DATE_SELECTION,
        selectedDate: date
    };
}

export function lastActivityDateTime(date) {
    return {
        type: LAST_ACTIVITY_DATE_TIME,
        lastActivityDateTime: date
    };
}